import { COLUMN_ORDERS, type GeoColumnOrder } from '@entities/geodesy';
import { FileDropZone } from '@shared/ui/FileDropZone';
import { Select } from '@shared/ui/Input';
import { ErrorText, FieldGrid, FieldLabel, Stack } from '@widgets/GeoSchemes';
import { ACCEPT_TABLE } from './constants';
import { Sub } from './styles';

interface Props {
  order: GeoColumnOrder;
  setOrder: (order: GeoColumnOrder) => void;
  busy: boolean;
  error: string | null;
  onImport: (file: File) => void;
}

export function CatalogImportSection({ order, setOrder, busy, error, onImport }: Props) {
  return (
    <Stack $gap={3}>
      <Sub>Каталог координат проектных точек</Sub>
      <FieldGrid $min={260}>
        <FieldLabel>
          Порядок колонок
          <Select
            value={order}
            onChange={(e) => setOrder(e.target.value === 'nyxhc' ? 'nyxhc' : 'nxyhc')}
          >
            {COLUMN_ORDERS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Select>
        </FieldLabel>
      </FieldGrid>
      <FileDropZone
        accept={ACCEPT_TABLE}
        compact
        disabled={busy}
        primary={busy ? 'Загружаем каталог…' : 'Каталог CSV, TXT или XLSX'}
        hint="разделители , ; табуляция пробел; запятая или точка в числах"
        onFile={onImport}
      />
      {error && <ErrorText role="alert">{error}</ErrorText>}
    </Stack>
  );
}
